import { render, staticRenderFns } from "./ClientPriceList.vue?vue&type=template&id=c92495aa&"
import script from "./ClientPriceList.vue?vue&type=script&lang=ts&"
export * from "./ClientPriceList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports